import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AlertService } from 'app/shared/services/alert.service';
import { AuthService } from '../password-grant/auth.service';

const USER_MANAGEMENT_ACCESS_DENIED_MESSAGE = 'Você não possui permissão para acessar esta funcionalidade.';

export const UserManagementGuard: CanActivateFn = (_route, _state): boolean => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const alertService = inject(AlertService);

  if (auth.isSelfServiceProfile()) {
    alertService.warning(USER_MANAGEMENT_ACCESS_DENIED_MESSAGE);
    void router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
